import React from "react";

// Atrapa errores de render para no dejar la pantalla en blanco.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Error de render:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          background: "#F4EFE6", padding: 24, fontFamily: "sans-serif",
        }}>
          <div style={{
            background: "#fff", borderRadius: 14, padding: 28, maxWidth: 460, width: "100%",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)", textAlign: "center",
          }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>🌾</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#5A3A22", marginBottom: 8 }}>
              Se produjo un error
            </div>
            <div style={{ fontSize: 13, color: "#8A7A66", marginBottom: 16, lineHeight: 1.5 }}>
              Algo falló al mostrar esta pantalla. Probá recargar; si sigue, sacale una
              captura al error de la consola (F12).
            </div>
            <pre style={{
              background: "#F4EFE6", borderRadius: 8, padding: "10px 12px", fontSize: 11,
              color: "#8A2A2A", textAlign: "left", overflow: "auto", maxHeight: 120, marginBottom: 16,
            }}>{String(this.state.error?.message || this.state.error)}</pre>
            <button onClick={() => window.location.reload()} style={{
              background: "#5A7A3A", color: "#fff", border: "none", borderRadius: 8,
              padding: "10px 20px", fontSize: 14, cursor: "pointer", fontWeight: 600,
            }}>Recargar</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
